import { toJS } from "mobx";
import axiosInstance from "../../services/axiosInstance";
import { axiosWithAbort } from "../../services/axiosWithAbort";
import { MESSAGE_CODES, showSuccessToast } from "../../services/toast";

export const dashboardAPI = {
  //////// 取得圓餅圖所需的資料
  async PieChartDataAPI(cId, year, month, gwpId, unit, standardId) {
    const requestBody = {
      companyIds: toJS(cId),
      year: year,
      baseYear: year,
      targetYear: year,
      month: month,
      gwpId: gwpId,
      unitId: unit,
      standardId: standardId,
    };
    try {
      // const response = await axiosInstance.post(
      //   `/api/dashboard/dashboard/pie_chart`,
      //   requestBody
      // );
      // return response.data.data; // 返回 API 的資料

      const response = await axiosWithAbort("PieChartData", {
        method: "post",
        url: `/api/dashboard/dashboard/pie_chart`,
        data: requestBody,
      });
      return response.data.data; // 返回 API 的資料
    } catch (error) {
      // handleAPIError(error, "Error fetching pie chart data");
      console.error("Error fetching pie chart data:", error);
      return []; // 失敗時回傳 null
    }
  },

  /////////////取得折線圖的資料
  async LineChartDataAPI(cId, year, month, gwpId, unit, standardId) {
    const requestBody = {
      companyIds: toJS(cId),
      year: year,
      baseYear: year,
      targetYear: year,
      month: month,
      gwpId: gwpId,
      unitId: unit,
      standardId: standardId,
    };
    try {
      // const response = await axiosInstance.post(
      //   `/api/dashboard/dashboard/line_chart`,
      //   requestBody
      // );
      // return response.data.data; // 返回 API 的資料

      const response = await axiosWithAbort("LineChartData", {
        method: "post",
        url: `/api/dashboard/dashboard/line_chart`,
        data: requestBody,
      });
      return response.data.data; // 返回 API 的資料
    } catch (error) {
      // handleAPIError(error, "Error fetching line chart data");
      console.error("Error fetching line chart data:", error);
      return []; // 失敗時回傳 null
    }
  },

  /////////////取得長條圖的資料
  async BarChartDataAPI(cId, year, month, gwpId, unit, standardId) {
    const requestBody = {
      companyIds: toJS(cId),
      year: year,
      baseYear: year,
      targetYear: year,
      month: month,
      gwpId: gwpId,
      unitId: unit,
      standardId: standardId,
    };
    try {
      // const response = await axiosInstance.post(
      //   `/api/dashboard/dashboard/bar_chart`,
      //   requestBody
      // );
      // return response.data.data; // 返回 API 的資料
      const response = await axiosWithAbort("BarChartData", {
        method: "post",
        url: `/api/dashboard/dashboard/bar_chart`,
        data: requestBody,
      });
      return response.data.data; // 返回 API 的資料
    } catch (error) {
      // handleAPIError(error, "Error fetching bar chart data");
      console.error("Error fetching bar chart data:", error);
      return []; // 失敗時回傳 null
    }
  },

  //////// 取得減碳頁面使用者輸入的基本資料
  async getDecarbonSetting(requestBody) {
    try {
      const res = await axiosInstance.post(
        `/api/dashboard/dashboard/get_decarbon_setting`,
        requestBody,
      );

      return res.data.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //////// 更新減碳頁面使用者輸入的基本資料
  async updateDecarbonSetting(requestBody) {
    try {
      const res = await axiosInstance.post(
        `/api/dashboard/dashboard/upsert_decarbon_setting`,
        requestBody,
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //////// 取得減碳頁面每年總碳排
  async getDecarbonYearEmission(requestBody) {
    try {
      const res = await axiosInstance.post(
        `/api/dashboard/dashboard/get_decarbon_years_emission`,
        requestBody,
      );
      return res.data.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //////// 更新減碳頁面每年總碳排
  async updateDecarbonYearEmission(requestBody) {
    try {
      const res = await axiosInstance.post(
        `/api/dashboard/dashboard/upsert_decarbon_years_emission`,
        requestBody,
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //////// 取得外部計算機Scopes
  async getDefaultScope(requestbody) {
    try {
      const res = await axiosInstance.post(
        `/api/dashboard/dashboard/get_computer_scopes`,
        requestbody,
      );

      return res.data.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //////// 取得所有計算機資料
  async getAllIntensityData(requestBody) {
    try {
      const res = await axiosInstance.post(
        `/api/dashboard/dashboard/get_decarbon_years_emission_computer`,
        requestBody,
      );

      return res.data.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //////// 更新計算機資料
  async updateIntensityData(requestBody) {
    try {
      const response = await axiosInstance.post(
        `/api/dashboard/dashboard/upsert_decarbon_years_emission_computer`,
        requestBody,
      );

      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.DASHBOARD_METRIC_UPDATE_SUCCESS,
      });
      return true;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  //////// 刪除計算機資料
  async deleteIntensity(userId, computerId) {
    try {
      const res = await axiosInstance.delete(
        `/api/dashboard/${userId}/${computerId}`,
      );

      showSuccessToast({
        apiData: res.data,
        scenarioCode: MESSAGE_CODES.DASHBOARD_METRIC_DELETE_SUCCESS,
      });
    } catch (err) {
      console.error(err);
    }
  },
};
